import { FileDelimitedIcon } from './FileDelimitedIcon';

/**
 * author: Austin Andrews
 * id 46650D6B-318F-4202-AB77-79A113EC77AA
 * name file-delimited
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-delimited.svg
 * tags
 * - Files / Folders 
 */
export const FileCsvIcon = FileDelimitedIcon;
export default FileCsvIcon